import { Cookies } from 'quasar'
import { type QSsrContext } from '#q-app'
import { parse } from 'cookie'
import { type AxiosResponse } from 'axios'

export const useCookieHelpers = () => {
  // refresh_token
  const setRefreshToken = (
    refreshToken: string,
    ssrContext?:
      | QSsrContext
      | {
          req: Request
          res: Response
        }
      | null
  ) => {
    const cookies = process.env.SERVER ? Cookies.parseSSR(ssrContext) : Cookies // otherwise we're on client

    cookies.set('refresh_token', refreshToken, {
      sameSite: process.env.WT_ENV === 'receiver' ? 'Lax' : 'None',
      path: '/',
      secure: true,
      expires: 365,
      other: process.env.WT_ENV === 'receiver' ? undefined : 'Partitioned;',
    })
  }

  const removeRefreshToken = (ssrContext?: QSsrContext | null) => {
    const cookies = process.env.SERVER ? Cookies.parseSSR(ssrContext) : Cookies // otherwise we're on client

    cookies.remove('refresh_token', {
      path: '/',
      sameSite: process.env.WT_ENV === 'receiver' ? 'Lax' : 'None',
      secure: true,
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } as any)
  }

  // ACCESS TOKEN
  const setAccessToken = (
    accessToken: string,
    ssrContext?:
      | QSsrContext
      | {
          req: Request
          res: Response
        }
      | null
  ) => {
    const cookies = process.env.SERVER ? Cookies.parseSSR(ssrContext) : Cookies // otherwise we're on client

    cookies.set('access_token', accessToken, {
      sameSite: process.env.WT_ENV === 'receiver' ? 'Lax' : 'None',
      path: '/',
      secure: true,
      expires: '1h',
      other: process.env.WT_ENV === 'receiver' ? undefined : 'Partitioned;',
    })
  }

  const removeAccessToken = (ssrContext?: QSsrContext | null) => {
    const cookies = process.env.SERVER ? Cookies.parseSSR(ssrContext) : Cookies // otherwise we're on client

    cookies.remove('access_token', {
      path: '/',
      sameSite: process.env.WT_ENV === 'receiver' ? 'Lax' : 'None',
      secure: true,
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } as any)
  }

  // SSR
  const ssrCookiesSet = (
    res: AxiosResponse,
    ssrContext?: QSsrContext | null
  ) => {
    if (ssrContext && res.config.headers['setCookie']) {
      const cookies = parse(res.config.headers['setCookie'])

      if (cookies.refresh_token) {
        setRefreshToken(cookies.refresh_token, ssrContext)
      }
      if (cookies.access_token) {
        setAccessToken(cookies.access_token, ssrContext)
      }
    }
  }

  return {
    setRefreshToken,
    removeRefreshToken,
    setAccessToken,
    removeAccessToken,
    ssrCookiesSet,
  }
}
